import { AsyncPipe, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProfileComponent } from './profile.component';



@NgModule({
  declarations: [ProfileComponent],
  imports: [
    AsyncPipe,
    NgIf],
})
export class ProfileModule { }
